module.exports = __webpack_public_path__ + "static/media/send_white.d35c190c.svg";